module.exports = __webpack_public_path__ + "static/media/3.a405af3b.svg";